import { FC, useMemo } from "react";

import classes from "./widget_link.module.css";

export const WidgetLink: FC = () => {
  const href = useMemo(
    () => `${window.location.origin}/home/templates${window.location.search}`,
    [],
  );

  return (
    <a href={href} target="_blank" rel="noreferrer" className={classes.link}>
      Go to smmplanner.com
    </a>
  );
};
